"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailIssuerService = void 0;
const issuer_email_ses_client_1 = require("@affinidi/issuer-email-ses-client");
const common_1 = require("@affinidi/common");
let EmailIssuerService = class EmailIssuerService {
    constructor({ basePath }) {
        this.getApi = (apiKey) => issuer_email_ses_client_1.DefaultApiFp({ apiKey, basePath: this.basePath });
        this.basePath = basePath;
    }
    initiate({ apiKey, emailAddress, id, holder, axios, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apicall = yield this.getApi(apiKey).apiInitiatePost({
                payload: {
                    id,
                    holder,
                    type: [],
                    data: {
                        emailAddress,
                    },
                },
            });
            const result = yield apicall(axios, this.basePath);
            return result.data;
        });
    }
    verify({ apiKey, code, id, holder, axios, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apicall = yield this.getApi(apiKey).apiVerifyPost({
                payload: {
                    id,
                    holder,
                    type: [],
                    data: { code },
                },
            });
            const result = yield apicall(axios, this.basePath);
            return result.data;
        });
    }
};
EmailIssuerService = __decorate([
    common_1.profile()
], EmailIssuerService);
exports.EmailIssuerService = EmailIssuerService;
//# sourceMappingURL=EmailIssuerService.js.map